import statisticApi from "api/statistic/statisticApi";
import React, { useEffect, useState } from "react";
import { useAnimatedNumber } from "../../animations/useAnimateNumber";
import RollingNumber from "../../animations/RollingNumber";

export default function AnimationCounter() {
  const [stats, setStats] = useState(null);

  return (
    <div className="w-full bg-reddark py-6">
      <div className="max-w-6xl mx-auto px-4 grid grid-cols-3 md:grid-cols-3 text-center text-white gap-10">
        <StatItem
          value={20}
          suffix="+"
          label="Years "
          size="text-2xl md:text-4xl"
        />
        <StatItem
          value={1000}
          suffix="+"
          label="Businesses"
          size="text-2xl md:text-4xl"
        />
        <StatItem
          value={8}
          suffix=""
          label="Countries"
          size="text-2xl md:text-4xl"
        />
        {/* <StatItemSpecial
          value={10}
          label="Average Client ROI"
          size="text-5xl md:text-6xl"
        /> */}
      </div>
    </div>
  );
}

/* ---------- STAT CARD COMPONENT ---------- */

function StatItem({ value, suffix = "", label, size }) {
  const animated = useAnimatedNumber(value);

  return (
    <div className="relative flex flex-col items-center justify-center ">
      <div className="text-lg md:text-3xl font-bold flex items-center gap-x-1">
        <RollingNumber value={animated} size={size} />
        {suffix}
      </div>

      <p className="mt-1 text-xs uppercase tracking-[0.2em] text-white/70">
        {label}
      </p>

      <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-16 w-[1px] bg-white/30 last:hidden" />
    </div>
  );
}

function StatItemSpecial({ value, label, size }) {
  const animated = useAnimatedNumber(value, 2000);

  return (
    <div className="relative flex flex-col items-center justify-center">
      <div className={`flex items-end font-bold ${size}`}>
        <span className="opacity-100">1</span>

        <span className="mx-2 text-red-200">:</span>

        <RollingNumber value={animated} size={size} />
      </div>
      <p className="mt-1 text-xs uppercase tracking-[0.2em] text-white/70">
        {label}
      </p>{" "}
    </div>
  );
}
